/**
 * Typed access to client-side environment variables.
 *
 * SECURITY: only VITE_* values are available in the browser. Never reference a
 * secret token here - those live exclusively in Supabase Edge Functions
 * (see docs/SECURITY.md sec 2 and .env.example).
 */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? "",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? "",
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN ?? "",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
} as const;

/** True once Supabase env vars are configured. Lets the app run with mock data before then. */
export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
